import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __EVENT_ADMIN_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ItemVM } from 'shell/view-models/item';
import { PecStateEnum } from 'shell/utils/utils-management-pec';
import { HttpResponseList } from 'shell/models/http-response';

interface StateElaborationPecListComponentProps {
  disabled?: boolean;
  value?: string | PecStateEnum;
  onChange: (state: string | PecStateEnum) => void;
  error?: boolean;
  label?: string;
  required?: boolean;
  id?: string;
}

type StateElaborationPecListModel = {
  key: {
    codice: string;
  };
  note: string;
  codiceOperatoreUltimoAggiornamento: string;
  descrizione: string;
  codiceOperatoreInserimento: string;
  timestampUltimoAggiornamento: string;
  descrizioneBreve: string;
  timestampInserimento: string;
};

const StateElaborationPecListComponent = ({
  disabled,
  onChange,
  value,
  required,
  error,
  label = 'Stato lavorazione',
  id = 'state-elaboration-pec',
}: StateElaborationPecListComponentProps): React.ReactElement => {
  const [stateList] = useHttpFetch<
    HttpResponseList<Array<StateElaborationPecListModel>>,
    Array<ItemVM>
  >(`${__EVENT_ADMIN_API_URL__}/pec/stato/list`, {
    onBootstrap: true,
    initialData: [],
    transformer: (
      response: AxiosResponse<HttpResponseList<Array<StateElaborationPecListModel>>>
    ) => {
      const { data } = response;

      const castedData = (data?.payload.list ||
        []) as unknown as Array<StateElaborationPecListModel>;

      return castedData.map((item) => ({
        id: item.key.codice,
        value: `${item.descrizioneBreve || ''} ${
          item.descrizione && item.descrizioneBreve ? '-' : ''
        } ${item.descrizione || ''}`,
      })) as Array<ItemVM>;
    },
  });

  const list = (stateList.data as Array<ItemVM>) || [];

  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value || ''}
        label={required ? `${label} *` : label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

StateElaborationPecListComponent.displayName = 'State Elaboration List component';

const StateElaborationPecList = memo(StateElaborationPecListComponent);

export default StateElaborationPecList as typeof StateElaborationPecListComponent;
